import { Row } from 'components/base';
import React, { PropsWithChildren } from 'react';

export const Container: React.FC<PropsWithChildren> = ({ children }) => (
  <Row fullHeight={true}>{children}</Row>
);
